export default {
  "country-large": () => import("/app/layouts/countryLarge.vue"),
  "country-small": () => import("/app/layouts/countrySmall.vue"),
  point: () => import("/app/layouts/point.vue"),
  radar: () => import("/app/layouts/radar.vue"),
  top: () => import("/app/layouts/top.vue")
}